export const dontShowNav = [
    {url: '/', label: 'Home', key: 'home', permissions: []},
    {url: '/sign-in', label: 'Sign in', key: 'sign-in', permissions: []},
    {url: '/sign-up', label: 'Sign up', key: 'sign-up', permissions: []},
    {url: '/sign-in/forgot-password', label: 'Forgot password', key: 'forgot-password', permissions: []},
]